import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { getPSPContent, normalizeKeyword } from "pages/PSPPage/ContentMap";
import ModuleLayout from "components/organisms/ModuleLayout/ModuleLayout";
import { Page } from "components/core/Page";
import { get } from "lodash";
import NotFoundErrorPage from "pages/ErrorPage/ErrorPage";
import { getMetadata } from "./utils/getMetadata";
import {
	buildReviewSchema,
	buildPageSchema,
	buildPSPUrl
} from "./utils/buildSchema";

function PSPPage(props) {
	const { handleSearch, match, keyword } = props;
	const keywordParam = get(match, "params.keyword") || keyword;
	const normalizedKeyword = normalizeKeyword(keywordParam);
	const pageContent = getPSPContent(normalizedKeyword);
	if (!pageContent) {
		return <NotFoundErrorPage {...props} />;
	}

	const metadata = getMetadata(normalizedKeyword);
	const reviewSchema = buildReviewSchema(pageContent);
	const canonicalUrl = buildPSPUrl(keywordParam);
	const heroImageUrl = `https://www.storage.com/images/psp/hero/${normalizedKeyword}-hero.webp`;
	const breadcrumbUrl = `/storage-solutions/${keywordParam}`;
	const schema = buildPageSchema(
		keywordParam,
		normalizedKeyword,
		pageContent.type,
		reviewSchema,
		metadata
	);
	const pageSchema = JSON.stringify(schema);

	return (
		<Page className="psp-page">
			<Helmet>
				<title>{metadata?.title}</title>
				<link
					rel="canonical"
					href={canonicalUrl}
				/>
				<meta
					name="description"
					content={metadata?.description}
				/>
				<meta
					property="og:title"
					content={metadata?.title}
				/>
				<meta
					property="og:description"
					content={metadata?.description}
				/>
				<meta
					property="og:url"
					content={canonicalUrl}
				/>
				<meta
					property="og:type"
					content="website"
				/>
				<meta
					property="og:image"
					content={heroImageUrl}
				/>
				<meta
					property="og:site_name"
					content="Storage.com"
				/>
				<meta
					name="twitter:card"
					content="summary_large_image"
				/>
				<meta
					name="twitter:site"
					content="@storage"
				/>
				<meta
					name="twitter:title"
					content={metadata?.title}
				/>
				<meta
					name="twitter:description"
					content={metadata?.description}
				/>
				<meta
					name="twitter:image"
					content={heroImageUrl}
				/>
			</Helmet>
			<ModuleLayout
				key={normalizedKeyword}
				content={pageContent}
				pageSchema={pageSchema}
				handleSearch={handleSearch}
				breadcrumbUrl={breadcrumbUrl}
			/>
		</Page>
	);
}

PSPPage.propTypes = {
	match: PropTypes.shape({
		params: PropTypes.shape({
			keyword: PropTypes.string.isRequired
		}).isRequired
	}).isRequired,
	keyword: PropTypes.string,
	handleSearch: PropTypes.func
};

export default PSPPage;
